/**
 * Voidfall structured scoring — procedural victory / cycle-end from local
 * PEŁNA źródło. Numeric Influence tables, per-scenario ties, Agenda VP and
 * battle reward values stay blocked or component-dependent. Do not invent
 * Combat Reference numbers.
 */

export type VoidfallScoringModuleId = 'base' | 'competitive' | 'coop' | 'solo';

export type VoidfallScoringTiming = 'mid-game' | 'end-game' | 'both';

export type VoidfallScoringSourceStatus =
  | 'verified'
  | 'component-dependent'
  | 'partial'
  | 'blocked';

export type VoidfallScoringRecord = {
  id: string;
  gameId: 'voidfall';
  moduleId: VoidfallScoringModuleId;
  category: 'victory' | 'cycle' | 'influence' | 'tie' | 'combat';
  element: string;
  timing: VoidfallScoringTiming;
  scoring: string;
  conditions: string;
  exceptions: string;
  returnsMeeple: string;
  sourceStatus: VoidfallScoringSourceStatus;
  verified: boolean;
  order: number;
  keywords: string[];
};

export const voidfallScoringRecords: VoidfallScoringRecord[] = [
  {
    id: 'vf-competitive-influence',
    gameId: 'voidfall',
    moduleId: 'competitive',
    category: 'victory',
    element: 'Rywalizacja — najwyższy Wpływ',
    timing: 'end-game',
    scoring:
      'Wygrywa gracz z największym Wpływem po trzecim Cyklu — o ile scenariusz nie zmienia liczby Cykli albo warunków końca.',
    conditions: 'Tryb rywalizacyjny; po punktowaniu końcowym trzeciego Cyklu (lub zgodnie ze scenariuszem).',
    exceptions: 'Scenariusz może zmienić liczbę Cykli / warunki końca — arkusz scenariusza.',
    returnsMeeple: 'N/A',
    sourceStatus: 'verified',
    verified: true,
    order: 10,
    keywords: ['rywalizacja', 'wpływ', 'zwycięstwo'],
  },
  {
    id: 'vf-coop-goal',
    gameId: 'voidfall',
    moduleId: 'coop',
    category: 'victory',
    element: 'Kooperacja — wspólny cel i uniknięcie porażki',
    timing: 'end-game',
    scoring:
      'Stół wygrywa tylko przy jednoczesnym osiągnięciu wspólnego celu i uniknięciu warunków porażki (Voidborn, Kryzysy, wymagania scenariusza). Sam wysoki Wpływ nie wystarczy, jeśli spełni się dowolny warunek porażki.',
    conditions: 'Tryb kooperacyjny; warunki z arkusza scenariusza.',
    exceptions: 'Konkretne Cele i warunki porażki: [DO WERYFIKACJI: katalog scenariuszy].',
    returnsMeeple: 'N/A',
    sourceStatus: 'verified',
    verified: true,
    order: 20,
    keywords: ['kooperacja', 'cel', 'porażka', 'voidborn'],
  },
  {
    id: 'vf-solo-goal',
    gameId: 'voidfall',
    moduleId: 'solo',
    category: 'victory',
    element: 'Solo — wspólny system celu / automy',
    timing: 'end-game',
    scoring:
      'Solo używa zbliżonych systemów do kooperacji: wspólny sukces wobec warunków porażki. Remisy priorytetów Voidborn rozstrzygaj regułą automy — nie wyborem wygodniejszym dla gracza.',
    conditions: 'Tryb solo; priorytety automy ze scenariusza.',
    exceptions: 'Nazwa scenariusza szkoleniowego First Game: DO WERYFIKACJI.',
    returnsMeeple: 'N/A',
    sourceStatus: 'verified',
    verified: true,
    order: 30,
    keywords: ['solo', 'automa', 'cel'],
  },
  {
    id: 'vf-cycle-end-procedure',
    gameId: 'voidfall',
    moduleId: 'base',
    category: 'cycle',
    element: 'Koniec Cyklu — procedura rozliczenia',
    timing: 'mid-game',
    scoring:
      'Kolejność: rozpatrz aktualne wydarzenie i punktowanie → sprawdź cele → produkcja/odświeżenie → przywróć karty i znaczniki → zaktualizuj Voidborn → przygotuj kolejny Cykl.',
    conditions: 'Po turach Skupienia bieżącego Cyklu (nie w środku tury).',
    exceptions: 'Scenariusz może zmieniać nazwy lub kolejność części — sprawdź arkusz.',
    returnsMeeple: 'N/A',
    sourceStatus: 'verified',
    verified: true,
    order: 40,
    keywords: ['cykl', 'koniec', 'produkcja', 'wydarzenie'],
  },
  {
    id: 'vf-end-after-cycle-3',
    gameId: 'voidfall',
    moduleId: 'base',
    category: 'cycle',
    element: 'Po trzecim Cyklu — punktowanie końcowe',
    timing: 'end-game',
    scoring:
      'Po trzecim Cyklu wykonaj punktowanie końcowe i sprawdź warunek zwycięstwa właściwy dla trybu. Nie graj „Cyklu 4 dla remisu”, chyba że scenariusz zmienia liczbę Cykli.',
    conditions: 'Domyślnie trzy Cykle; wyjątki tylko ze scenariusza.',
    exceptions: '—',
    returnsMeeple: 'N/A',
    sourceStatus: 'verified',
    verified: true,
    order: 50,
    keywords: ['cykl', '3', 'końcowe', 'punktowanie'],
  },
  {
    id: 'vf-influence-sources',
    gameId: 'voidfall',
    moduleId: 'base',
    category: 'influence',
    element: 'Źródła Wpływu (kategorie)',
    timing: 'both',
    scoring:
      'Wpływ zdobywasz przez rozwój sektorów, realizację Agend, wydarzenia Cykli, walkę i kontrolę — według scenariusza i tekstów komponentów. Wartości punktowe Agend, wydarzeń, technologii i nagród bitwy: nadruk / arkusz — nie z pamięci aplikacji.',
    conditions: 'W trakcie Cykli i przy rozliczeniu.',
    exceptions:
      'Katalogi Agend, wydarzeń, frakcji i technologii: DO WERYFIKACJI. Agenda acquiredThisTurn nie działa w turze zdobycia.',
    returnsMeeple: 'N/A',
    sourceStatus: 'component-dependent',
    verified: true,
    order: 60,
    keywords: ['wpływ', 'agenda', 'wydarzenie', 'sektor'],
  },
  {
    id: 'vf-scenario-tables',
    gameId: 'voidfall',
    moduleId: 'base',
    category: 'influence',
    element: 'Tabele punktowania scenariusza',
    timing: 'end-game',
    scoring:
      'Szczegółowe tabele punktowania per scenariusz nie są w lokalnym szkicu. Stosuj wyłącznie arkusz scenariusza + Rulebook/Glossary — [DO WERYFIKACJI: tabele punktowania].',
    conditions: 'Punktowanie końcowe i rozliczenia wskazane przez scenariusz.',
    exceptions: 'Nie inventuj uniwersalnej tabeli VP dla wszystkich map.',
    returnsMeeple: 'N/A',
    sourceStatus: 'blocked',
    verified: false,
    order: 70,
    keywords: ['tabela', 'scenariusz', 'blocker'],
  },
  {
    id: 'vf-ties',
    gameId: 'voidfall',
    moduleId: 'base',
    category: 'tie',
    element: 'Remis Wpływu',
    timing: 'end-game',
    scoring:
      'Lokalne źródło nie podaje uniwersalnej reguły remisu Wpływu. Przy równym wyniku stosuj regułę z arkusza scenariusza albo oficjalnego Rulebook/Glossary — nie wymyślaj dogrywki przy stole. [DO WERYFIKACJI: remisy]',
    conditions: 'Równy Wpływ po punktowaniu końcowym (rywalizacja).',
    exceptions: 'Nie głosuj „kto bardziej zasłużył”.',
    returnsMeeple: 'N/A',
    sourceStatus: 'blocked',
    verified: false,
    order: 80,
    keywords: ['remis', 'wpływ', 'tie'],
  },
  {
    id: 'vf-battle-rewards',
    gameId: 'voidfall',
    moduleId: 'base',
    category: 'combat',
    element: 'Nagrody / Wpływ po Bitwie',
    timing: 'mid-game',
    scoring:
      'Po wyniku Bitwy i kontroli sektora rozpatrz Skażenie, nagrody i skutki scenariusza wskazane przez komponenty. Nie przyznawaj nagród „za samą walkę”, jeśli scenariusz tego nie daje. Siła jednostek i pełna tabela wyniku Bitwy: Combat Reference — BLOCKED liczbowo w aplikacji.',
    conditions: 'Po stratach i ustaleniu, kto przejął lub obronił sektor.',
    exceptions:
      'Wzajemne zniszczenie / remis Bitwy / nieudana inwazja — wyłącznie Combat Reference + Rulebook.',
    returnsMeeple: 'N/A',
    sourceStatus: 'component-dependent',
    verified: true,
    order: 90,
    keywords: ['bitwa', 'nagroda', 'skażenie', 'combat reference'],
  },
  {
    id: 'vf-contamination-scoring',
    gameId: 'voidfall',
    moduleId: 'base',
    category: 'influence',
    element: 'Skażenie a punktowanie',
    timing: 'both',
    scoring:
      'Skażenie może wpływać na punktowanie i status Czystego sektora (oraz blokować rozwój / zmianę populacji), ale nie wyłącza automatycznie produkcji. Konkretne premie/kary — z arkusza / kart, nie z domyślnej „kary za walkę”.',
    conditions: 'Sektor ze Skażeniem; efekty scenariusza lub kart.',
    exceptions: '—',
    returnsMeeple: 'N/A',
    sourceStatus: 'component-dependent',
    verified: true,
    order: 100,
    keywords: ['skażenie', 'punktowanie', 'czysty'],
  },
];

export function filterVoidfallScoring(
  activeModuleIds: VoidfallScoringModuleId[],
  options: { showAll?: boolean; timingFilter?: VoidfallScoringTiming | 'all' } = {}
): VoidfallScoringRecord[] {
  const timing = options.timingFilter ?? 'all';
  const rows = options.showAll
    ? voidfallScoringRecords.slice()
    : (() => {
        const enabled = new Set(activeModuleIds);
        enabled.add('base');
        return voidfallScoringRecords.filter((r) => enabled.has(r.moduleId));
      })();
  return rows
    .filter((r) => {
      if (timing === 'all') return true;
      if (r.timing === 'both') return true;
      return r.timing === timing;
    })
    .sort((a, b) => a.order - b.order);
}

export function validateVoidfallScoringTables(): string[] {
  const issues: string[] = [];
  const ids = new Set<string>();
  for (const r of voidfallScoringRecords) {
    if (ids.has(r.id)) issues.push(`Duplicate VF scoring id ${r.id}`);
    ids.add(r.id);
    if (!r.element.trim() || !r.scoring.trim()) {
      issues.push(`Incomplete VF scoring ${r.id}`);
    }
  }
  const baseOnly = filterVoidfallScoring(['base']);
  if (!baseOnly.every((r) => r.moduleId === 'base')) {
    issues.push('Base filter leaked non-base VF rows');
  }
  if (!baseOnly.some((r) => r.id === 'vf-cycle-end-procedure')) {
    issues.push('Missing cycle-end procedure row');
  }
  if (baseOnly.some((r) => r.moduleId === 'competitive')) {
    issues.push('Competitive victory visible without competitive module');
  }
  const competitive = filterVoidfallScoring(['base', 'competitive']);
  if (!competitive.some((r) => r.id === 'vf-competitive-influence')) {
    issues.push('Competitive scoring missing when enabled');
  }
  if (competitive.some((r) => r.moduleId === 'coop' || r.moduleId === 'solo')) {
    issues.push('Coop/solo leaked into competitive filter');
  }
  const coop = filterVoidfallScoring(['base', 'coop']);
  if (!coop.some((r) => r.id === 'vf-coop-goal')) {
    issues.push('Coop scoring missing when enabled');
  }
  const showAll = filterVoidfallScoring(['base'], { showAll: true });
  if (showAll.length <= baseOnly.length) {
    issues.push('showAll should include mode-specific VF rows');
  }
  const end = filterVoidfallScoring(['base', 'competitive'], {
    timingFilter: 'end-game',
  });
  if (!end.some((r) => r.id === 'vf-competitive-influence')) {
    issues.push('end-game filter missing competitive victory');
  }
  const blocked = voidfallScoringRecords.filter((r) => r.sourceStatus === 'blocked');
  if (!blocked.some((r) => r.id === 'vf-ties')) {
    issues.push('Expected blocked ties row');
  }
  if (!blocked.some((r) => r.id === 'vf-scenario-tables')) {
    issues.push('Expected blocked scenario tables row');
  }
  return issues;
}
